import { PublishStatus } from 'src/api-service';
import { MarketCountry, MarketCurrency, SortOptionItem, SupportedLanguage, VendorCurrency } from '@app/shared/interface/webshop.interface';

// ============================================================
// PUBLISHING
// ============================================================

// ==================== PUBLISH STATUS ====================
export const PUBLISH_STATUS_OPTIONS = [
    { label: 'Utkast', value: PublishStatus.Draft },
    { label: 'Publicerad', value: PublishStatus.Published },
];

// ============================================================
// MARKETS, LANGUAGES & CURRENCIES
// ============================================================

export const VAT_RATE = 0.25;

// ==================== MARKET COUNTRIES ====================
// Country options for country dropdowns
export const MARKET_COUNTRIES: MarketCountry[] = [
    { countryCode: 'DK', label: 'Danmark', flagUrl: 'https://flagcdn.com/16x12/dk.png' },
    { countryCode: 'FI', label: 'Finland', flagUrl: 'https://flagcdn.com/16x12/fi.png' },
    { countryCode: 'NO', label: 'Norge', flagUrl: 'https://flagcdn.com/16x12/no.png' },
    { countryCode: 'SE', label: 'Sverige', flagUrl: 'https://flagcdn.com/16x12/se.png' },
];

// ==================== MARKET CURRENCIES ====================
// Currency options for currency dropdowns
export const MARKET_CURRENCIES: MarketCurrency[] = [
    { currencyCode: 'DKK', label: 'DKK - Danska kronor', flagUrl: 'https://flagcdn.com/16x12/dk.png' },
    { currencyCode: 'EUR', label: 'EUR - Euro', flagUrl: 'https://flagcdn.com/16x12/fi.png' },
    { currencyCode: 'NOK', label: 'NOK - Norska kronor', flagUrl: 'https://flagcdn.com/16x12/no.png' },
    { currencyCode: 'SEK', label: 'SEK - Svenska kronor', flagUrl: 'https://flagcdn.com/16x12/se.png' },
];

// Maps a market currency code to its country code
export const CURRENCY_TO_COUNTRY_CODE: Record<string, string> = {
    DKK: 'DK',
    EUR: 'FI',
    NOK: 'NO',
    SEK: 'SE',
};

// ==================== SUPPORTED LANGUAGES ====================
// All languages available in the application (Nordic countries + English)
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
    { languageCode: 'sv', label: 'Svenska', flagUrl: 'https://flagcdn.com/16x12/se.png' },
    { languageCode: 'en', label: 'English', flagUrl: 'https://flagcdn.com/16x12/gb.png' },
    { languageCode: 'da', label: 'Dansk', flagUrl: 'https://flagcdn.com/16x12/dk.png' },
    { languageCode: 'fi', label: 'Suomi', flagUrl: 'https://flagcdn.com/16x12/fi.png' },
    { languageCode: 'no', label: 'Norsk', flagUrl: 'https://flagcdn.com/16x12/no.png' },
];

// ==================== VENDOR CURRENCIES ====================
// All currencies that vendors/brands can invoice in
export const SUPPORTED_VENDOR_CURRENCIES: VendorCurrency[] = [
    { code: 'AUD', label: 'AUD - Australiensiska dollar', flagUrl: 'https://flagcdn.com/16x12/au.png' },
    { code: 'CAD', label: 'CAD - Kanadensiska dollar', flagUrl: 'https://flagcdn.com/16x12/ca.png' },
    { code: 'CHF', label: 'CHF - Schweiziska franc', flagUrl: 'https://flagcdn.com/16x12/ch.png' },
    { code: 'DKK', label: 'DKK - Danska kronor', flagUrl: 'https://flagcdn.com/16x12/dk.png' },
    { code: 'EUR', label: 'EUR - Euro', flagUrl: 'https://flagcdn.com/16x12/eu.png' },
    { code: 'GBP', label: 'GBP - Brittiska pund', flagUrl: 'https://flagcdn.com/16x12/gb.png' },
    { code: 'NOK', label: 'NOK - Norska kronor', flagUrl: 'https://flagcdn.com/16x12/no.png' },
    { code: 'SEK', label: 'SEK - Svenska kronor', flagUrl: 'https://flagcdn.com/16x12/se.png' },
    { code: 'USD', label: 'USD - US Dollar', flagUrl: 'https://flagcdn.com/16x12/us.png' },
];

// ============================================================
// PRODUCT CATALOG
// ============================================================

// ==================== SORTING ====================
export const SORT_OPTIONS: readonly SortOptionItem[] = [
    { value: 'name-asc', labelKey: 'PAGES.PRODUCTCATALOG.SORTNAMEASC' },
    { value: 'price-asc', labelKey: 'PAGES.PRODUCTCATALOG.SORTPRICEASC' },
    { value: 'price-desc', labelKey: 'PAGES.PRODUCTCATALOG.SORTPRICEDESC' },
    { value: 'stock-desc', labelKey: 'PAGES.PRODUCTCATALOG.SORTSTOCK' },
];

// ==================== PRICE FILTER ====================
// Fallback slider max when no product prices are available
export const DEFAULT_MAX_PRICE = 30000;

// ==================== COMMENTS ====================
export const INITIAL_VISIBLE_COMMENTS = 2;
export const SHOW_MORE_STEP = 10;

// ============================================================
// UI
// ============================================================

// ==================== BREAKPOINTS ====================
// Keep in sync with the SCSS mobile breakpoint
export const MOBILE_QUERY = '(max-width: 767.98px)';

// ==================== TIMING ====================
// Delay before dispatching typed input (search, price fields)
export const INPUT_DEBOUNCE_MS = 300;
